import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import logo from "@/assets/logo-northquest.svg";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background rounded-t-[3rem] mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src={logo} 
                alt="Northquest Logo" 
                className="h-10"
              />
            </Link>
            <p className="text-sm text-background/70">
              Empowering Visionary Brands to Grow with Purpose and Thrive with Impact.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4 text-background">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background/70 hover:text-background transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-background/70 hover:text-background transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-background/70 hover:text-background transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/commitments" className="text-sm text-background/70 hover:text-background transition-colors">
                  Commitments
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold mb-4 text-background">Services</h3>
            <ul className="space-y-2">
              <li className="text-sm text-background/70">Website Marketing</li>
              <li className="text-sm text-background/70">Mobile App Services</li>
              <li className="text-sm text-background/70">AI for Marketing</li>
              <li className="text-sm text-background/70">Social Media</li>
              <li className="text-sm text-background/70">Digital Marketing</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold mb-4 text-background">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone size={16} className="mt-1 text-accent flex-shrink-0" />
                <a href="tel:+442037535435" className="text-sm text-background/70 hover:text-background transition-colors">
                  +44 203 753 5435
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Mail size={16} className="mt-1 text-accent flex-shrink-0" />
                <a href="mailto:inquiry@northquestmarketing.co.uk" className="text-sm text-background/70 hover:text-background transition-colors">
                  inquiry@northquestmarketing.co.uk
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1 text-accent flex-shrink-0" />
                <span className="text-sm text-background/70">
                  Level 30, The Leadenhall Building, 122 Leadenhall Street, London, EC3V 4AB
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-background/20 text-center text-sm text-background/70">
          <p>© {new Date().getFullYear()} Northquest Marketing. All rights reserved.</p>
          <p className="mt-2">
            Monday – Friday, 9:00 am – 5:00 pm
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
